export default __webpack_public_path__ + "6c28a374803da67bd85d7ae2a55d0487.png";